module.exports = __webpack_public_path__ + "img/scorestar.3b7506fd.svg";